import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { getConsent, setConsent, trackPageview } from "@/lib/analytics";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
    if (value === "all") trackPageview();
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[80] bg-ink text-paper p-6 shadow-2xl"
        >
          <p className="text-sm leading-relaxed text-zinc-300 mb-5">
            Diese Website nutzt technisch notwendige Speicherung und — nur mit
            deiner Zustimmung — eine anonyme, cookiearme Besucherstatistik
            (keine Werbung, keine Weitergabe, keine Profile). Details in der{" "}
            <a href="/datenschutz" className="underline hover:text-goldlight transition-colors">
              Datenschutzerklärung
            </a>
            .
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              onClick={() => choose("all")}
              data-testid="cookie-accept-all-button"
              className="bg-paper text-ink px-6 py-2.5 text-xs uppercase tracking-[0.25em] hover:bg-goldlight transition-colors duration-300"
            >
              Alle akzeptieren
            </button>
            <button
              onClick={() => choose("necessary")}
              data-testid="cookie-accept-button"
              className="border border-white/25 text-zinc-300 px-6 py-2.5 text-xs uppercase tracking-[0.25em] hover:border-goldlight hover:text-goldlight transition-colors duration-300"
            >
              Nur notwendige
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
